// apps/web/src/views/app-views/roulette/settings/index.js

import {
  Alert,
  Button,
  Card,
  Col,
  Divider,
  Form,
  Image,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Switch,
  Tabs,
  Typography,
  Upload,
  message,
} from 'antd'
import { UploadOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'
import { api } from 'services/api'
import UploadService from 'services/UploadService'

const { Title, Text } = Typography

const API_BASE_URL = 'https://games.nlbsolucoes.com/api'

const getImageUrl = (url) => {
  if (!url) return null
  if (url.startsWith('http')) return url
  return `${API_BASE_URL}${url}`
}

const defaultBenefitItems = [
  { icon: '🎁', text: 'Prêmios incríveis' },
  { icon: '✨', text: '100% gratuito' },
  { icon: '🏆', text: 'Rápido e fácil' },
]

const normalizeGameSettings = (game) => ({
  ...game,

  layoutOrientation: game.layoutOrientation || 'AUTO',
  layoutMode: game.layoutMode || 'CENTER',

  wheelModel: game.wheelModel || 'MODEL_1',
  wheelPosition: game.wheelPosition || 'CENTER',
  wheelSize: game.wheelSize || 680,

  showLogo: game.showLogo ?? true,
  showTitle: game.showTitle ?? true,
  showSubtitle: game.showSubtitle ?? true,
  showPlayHint: game.showPlayHint ?? true,
  showTopBenefits: game.showTopBenefits ?? true,
  showBottomBanner: game.showBottomBanner ?? false,
  showPrizeImage: game.showPrizeImage ?? true,
  disableContextMenu: game.disableContextMenu ?? false,
  fullscreenEnabled: game.fullscreenEnabled ?? false,
  logoVerticalPosition: game.logoVerticalPosition || 'TOP',
  logoHorizontalPosition: game.logoHorizontalPosition || 'LEFT',
  logoSize: game.logoSize || 130,

  titleColor: game.titleColor || '#ffffff',
  titleFontSize: game.titleFontSize || 48,
  titleFontWeight: game.titleFontWeight || '950',

  subtitleColor: game.subtitleColor || '#ffffff',
  subtitleFontSize: game.subtitleFontSize || 20,
  subtitleFontWeight: game.subtitleFontWeight || '700',

  playHintText: game.playHintText || 'Clique em GIRAR para tentar a sorte!',
  playHintColor: game.playHintColor || '#ffffff',
  playHintFontSize: game.playHintFontSize || 18,
  playHintFontWeight: game.playHintFontWeight || '800',

  topBenefitsTitle: game.topBenefitsTitle || '',
  topBenefitsItems: Array.isArray(game.topBenefitsItems)
    ? game.topBenefitsItems
    : defaultBenefitItems,
  topBenefitsBackground: game.topBenefitsBackground || 'rgba(20, 8, 54, 0.65)',
  topBenefitsBorderColor: game.topBenefitsBorderColor || 'rgba(173, 92, 255, 0.75)',
  topBenefitsTextColor: game.topBenefitsTextColor || '#ffffff',
  topBenefitsBorderRadius: game.topBenefitsBorderRadius || 18,
  topBenefitsPadding: game.topBenefitsPadding || 16,
  topBenefitsGap: game.topBenefitsGap || 24,

  bottomBannerIcon: game.bottomBannerIcon || '🛡️',
  bottomBannerTitle: game.bottomBannerTitle || 'Seus dados estão protegidos com segurança',
  bottomBannerSubtitle: game.bottomBannerSubtitle || 'Participação 100% segura e dentro da LGPD',
  bottomBannerBackground: game.bottomBannerBackground || 'rgba(20, 8, 54, 0.65)',
  bottomBannerBorderColor: game.bottomBannerBorderColor || 'rgba(173, 92, 255, 0.75)',
  bottomBannerTextColor: game.bottomBannerTextColor || '#ffffff',
  bottomBannerBorderRadius: game.bottomBannerBorderRadius || 18,
  bottomBannerPadding: game.bottomBannerPadding || 16,

  requireName: game.requireName ?? true,
  requireCpf: game.requireCpf ?? false,
  requireEmail: game.requireEmail ?? false,
  requirePhone: game.requirePhone ?? true,

  onePlayPerCpf: game.onePlayPerCpf ?? false,
  onePlayPerEmail: game.onePlayPerEmail ?? false,
  onePlayPerPhone: game.onePlayPerPhone ?? true,

  prizePageEnabled: game.prizePageEnabled ?? true,
  prizePageBackgroundUrl: game.prizePageBackgroundUrl || '',
  prizePageLogoUrl: game.prizePageLogoUrl || '',
  prizePageFrameUrl: game.prizePageFrameUrl || '',
  prizePageTitle: game.prizePageTitle || 'PARABÉNS!',
  prizePageSubtitle: game.prizePageSubtitle || 'VOCÊ GANHOU',
  prizePageTitleColor: game.prizePageTitleColor || '#fff200',
  prizePageSubtitleColor: game.prizePageSubtitleColor || '#00a6c8',
  prizePagePrizeNameColor: game.prizePagePrizeNameColor || '#fff200',

  prizePageShowPrizeImage: game.prizePageShowPrizeImage ?? true,
  prizePageAutoReturn: game.prizePageAutoReturn ?? true,
  prizePageReturnDelay: game.prizePageReturnDelay || 8000,

  // ==========================================
  // REDIRECIONAMENTO EXTERNO
  // ==========================================

  externalRedirectEnabled:
    game.externalRedirectEnabled ?? false,

  externalRedirectUrl:
    game.externalRedirectUrl || '',

  externalRedirectMode:
    game.externalRedirectMode || 'BUTTON',

  externalRedirectButtonText:
    game.externalRedirectButtonText || 'Continuar',

  prizePageTitleFontSize:
    Number(
      game.prizePageTitleFontSize ||
      76,
    ),

  prizePageTitleFontWeight:
    game.prizePageTitleFontWeight ||
    '950',

  prizePageTitleSpacing:
    Number(
      game.prizePageTitleSpacing ??
      24,
    ),

  prizePageSubtitleFontSize:
    Number(
      game.prizePageSubtitleFontSize ||
      48,
    ),

  prizePageSubtitleFontWeight:
    game.prizePageSubtitleFontWeight ||
    '900',

  prizePageSubtitleSpacing:
    Number(
      game.prizePageSubtitleSpacing ??
      14,
    ),

  prizePagePrizeNameFontSize:
    Number(
      game.prizePagePrizeNameFontSize ||
      84,
    ),

  prizePagePrizeNameFontWeight:
    game.prizePagePrizeNameFontWeight ||
    '950',

  prizePagePrizeTextTransform:
    game.prizePagePrizeTextTransform ||
    'uppercase',

  participationLimitType: game.participationLimitType || 'GAME',
  participationLimitMinutes: game.participationLimitMinutes || 60,

  leadCapturePosition: game.leadCapturePosition || 'BEFORE_GAME',
  // Designer — tela do formulário
  formPageEnabled:
    game.formPageEnabled ?? true,

  formPageBackgroundUrl:
    game.formPageBackgroundUrl || '',

  formPageBackgroundColor:
    game.formPageBackgroundColor || '#050505',

  formPageOverlayColor:
    game.formPageOverlayColor || '#000000',

  formPageOverlayOpacity:
    game.formPageOverlayOpacity ?? 35,

  formPageBackgroundBlur:
    game.formPageBackgroundBlur ?? 0,

  formPageShowLogo:
    game.formPageShowLogo ?? true,

  formPageLogoUrl:
    game.formPageLogoUrl || '',

  formPageLogoSize:
    game.formPageLogoSize || 180,

  formPageLogoVerticalPosition:
    game.formPageLogoVerticalPosition || 'TOP',

  formPageLogoHorizontalPosition:
    game.formPageLogoHorizontalPosition || 'CENTER',

  formPageShowTitle:
    game.formPageShowTitle ?? true,

  formPageTitle:
    game.formPageTitle || 'Cadastre-se',

  formPageTitleColor:
    game.formPageTitleColor || '#1f2937',

  formPageTitleFontSize:
    game.formPageTitleFontSize || 32,

  formPageTitleFontWeight:
    game.formPageTitleFontWeight || '800',

  formPageShowSubtitle:
    game.formPageShowSubtitle ?? true,

  formPageSubtitle:
    game.formPageSubtitle ||
    'Preencha seus dados para participar',

  formPageSubtitleColor:
    game.formPageSubtitleColor || '#6b7280',

  formPageSubtitleFontSize:
    game.formPageSubtitleFontSize || 16,

  formPageSubtitleFontWeight:
    game.formPageSubtitleFontWeight || '400',

  formPageCardBackground:
    game.formPageCardBackground || '#ffffff',

  formPageCardOpacity:
    game.formPageCardOpacity ?? 96,

  formPageCardBorderColor:
    game.formPageCardBorderColor || '#e5e7eb',

  formPageCardBorderWidth:
    game.formPageCardBorderWidth ?? 1,

  formPageCardBorderRadius:
    game.formPageCardBorderRadius || 24,

  formPageCardShadow:
    game.formPageCardShadow ?? true,

  formPageCardWidth:
    game.formPageCardWidth || 560,

  formPageCardPadding:
    game.formPageCardPadding || 32,

  formPageCardPosition:
    game.formPageCardPosition ||
    'CENTER',

  formPageLabelColor:
    game.formPageLabelColor ||
    '#374151',

  formPageLabelFontSize:
    Number(
      game.formPageLabelFontSize ||
      14,
    ),

  formPageLabelFontWeight:
    game.formPageLabelFontWeight ||
    '700',

  formPageInputBackground:
    game.formPageInputBackground ||
    '#ffffff',

  formPageInputTextColor:
    game.formPageInputTextColor ||
    '#111827',

  formPageInputPlaceholderColor:
    game.formPageInputPlaceholderColor ||
    '#9ca3af',

  formPageInputBorderColor:
    game.formPageInputBorderColor ||
    '#d1d5db',

  formPageInputFocusColor:
    game.formPageInputFocusColor ||
    '#7c3aed',

  formPageInputBorderRadius:
    Number(
      game.formPageInputBorderRadius ||
      8,
    ),

  formPageInputHeight:
    Number(
      game.formPageInputHeight ||
      44,
    ),

  formPageInputFontSize:
    Number(
      game.formPageInputFontSize ||
      16,
    ),

  formPageConsentTextColor:
    game.formPageConsentTextColor ||
    '#4b5563',

  formPageButtonText:
    game.formPageButtonText || 'Começar jogo',

  formPageButtonColor:
    game.formPageButtonColor || '#f97316',

  formPageButtonTextColor:
    game.formPageButtonTextColor || '#ffffff',

  formPageButtonHeight:
    game.formPageButtonHeight || 54,

  formPageButtonBorderRadius:
    game.formPageButtonBorderRadius || 10,

  // ==========================================
  // TELA DE ESPERA
  // ==========================================

  idleScreenEnabled:
    game.idleScreenEnabled ?? false,

  idleScreenDelay:
    Number(
      game.idleScreenDelay || 30000,
    ),

  idleScreenShowBackground:
    game.idleScreenShowBackground ??
    true,

  idleScreenBackgroundUrl:
    game.idleScreenBackgroundUrl || '',

  idleScreenShowVideo:
    game.idleScreenShowVideo ??
    false,

  idleScreenVideoUrl:
    game.idleScreenVideoUrl || '',

  idleScreenMessage:
    game.idleScreenMessage ||
    'Toque na tela para começar',

  idleScreenMessageColor:
    game.idleScreenMessageColor ||
    '#ffffff',

  idleScreenMessageFontSize:
    Number(
      game.idleScreenMessageFontSize ||
      48,
    ),

  idleScreenMessagePosition:
    game.idleScreenMessagePosition ||
    'CENTER',

  idleScreenOverlayColor:
    game.idleScreenOverlayColor ||
    '#000000',

  idleScreenOverlayOpacity:
    Number(
      game.idleScreenOverlayOpacity ??
      20,
    ),
})

const wheelModelDescriptions = {
  MODEL_1: 'Cassino Neon com bolinhas/lâmpadas externas ao redor da roleta.',
  MODEL_2: 'Clássica Dourada com acabamento premium.',
  MODEL_3: 'Minimalista, limpa e sem bolinhas ao redor.',
  MODEL_4: 'Premium LED com brilho mais forte.',
  MODEL_5: 'Retrô Vegas com visual mais chamativo.',
  MODEL_6: 'Futurista com efeito neon moderno.',
  MODEL_7: 'Cassino Clássico com cores douradas.',
}

const SettingsPage = () => {
  const [form] = Form.useForm()
  const [games, setGames] = useState([])
  const [gameId, setGameId] = useState()
  const [loading, setLoading] = useState(false)
  const [uploadingLogo, setUploadingLogo] = useState(false)
  const [uploadingBackground, setUploadingBackground] = useState(false)

  const [uploadingPrizePageBackground, setUploadingPrizePageBackground] = useState(false)
  const [uploadingPrizePageLogo, setUploadingPrizePageLogo] = useState(false)
  const [uploadingPrizePageFrame, setUploadingPrizePageFrame] = useState(false)
  const [
    uploadingFormPageBackground,
    setUploadingFormPageBackground,
  ] = useState(false)

  const [
    uploadingFormPageLogo,
    setUploadingFormPageLogo,
  ] = useState(false)

  const [
    uploadingIdleBackground,
    setUploadingIdleBackground,
  ] = useState(false)

  const [
    uploadingIdleVideo,
    setUploadingIdleVideo,
  ] = useState(false)

  const uploadLogo = async ({ file, onSuccess, onError }) => {
    try {
      setUploadingLogo(true)

      const response = await UploadService.image(file)
      const data = response?.data || response



      form.setFieldsValue({
        logoUrl: data.url,
      })

      message.success('Logo enviada')
      onSuccess(data)
    } catch (error) {
      console.error(error)
      message.error('Erro ao enviar logo')
      onError(error)
    } finally {
      setUploadingLogo(false)
    }
  }

  const uploadBackground = async ({ file, onSuccess, onError }) => {
    try {
      setUploadingBackground(true)

      const response = await UploadService.image(file)
      const data = response?.data || response



      form.setFieldsValue({
        backgroundUrl: data.url,
      })

      message.success('Imagem de fundo enviada')
      onSuccess(data)
    } catch (error) {
      console.error(error)
      message.error('Erro ao enviar imagem de fundo')
      onError(error)
    } finally {
      setUploadingBackground(false)
    }
  }

  const uploadPrizePageBackground = async ({
    file,
    onSuccess,
    onError,
  }) => {
    try {
      setUploadingPrizePageBackground(true)

      if (!gameId) {
        throw new Error(
          'Selecione um jogo antes de enviar a imagem',
        )
      }

      const response =
        await UploadService.image(file)

      const data =
        response?.data || response

      if (!data?.url) {
        throw new Error(
          'A API não retornou a URL da imagem',
        )
      }

      form.setFieldsValue({
        prizePageBackgroundUrl:
          data.url,
      })

      /*
       * Salva imediatamente no banco.
       */
      await api.patch(
        `/games/${gameId}`,
        {
          prizePageBackgroundUrl:
            data.url,
        },
      )

      /*
       * Atualiza também a lista local,
       * evitando que um reload interno restaure
       * o valor anterior.
       */
      setGames((currentGames) =>
        currentGames.map((game) =>
          game.id === gameId
            ? {
              ...game,
              prizePageBackgroundUrl:
                data.url,
            }
            : game,
        ),
      )

      message.success(
        'Fundo da página do prêmio enviado e salvo',
      )

      onSuccess(data)
    } catch (error) {
      console.error(
        'ERRO UPLOAD FUNDO PRÊMIO:',
        error,
      )

      message.error(
        error?.response?.data?.message ||
        error?.message ||
        'Erro ao enviar fundo da página do prêmio',
      )

      onError(error)
    } finally {
      setUploadingPrizePageBackground(
        false,
      )
    }
  }

  const uploadPrizePageLogo = async ({
    file,
    onSuccess,
    onError,
  }) => {
    try {
      setUploadingPrizePageLogo(true)

      if (!gameId) {
        throw new Error(
          'Selecione um jogo antes de enviar a imagem',
        )
      }

      const response =
        await UploadService.image(file)

      const data =
        response?.data || response

      if (!data?.url) {
        throw new Error(
          'A API não retornou a URL da imagem',
        )
      }

      form.setFieldsValue({
        prizePageLogoUrl:
          data.url,
      })

      await api.patch(
        `/games/${gameId}`,
        {
          prizePageLogoUrl:
            data.url,
        },
      )

      setGames((currentGames) =>
        currentGames.map((game) =>
          game.id === gameId
            ? {
              ...game,
              prizePageLogoUrl:
                data.url,
            }
            : game,
        ),
      )

      message.success(
        'Logo da página do prêmio enviada e salva',
      )

      onSuccess(data)
    } catch (error) {
      console.error(
        'ERRO UPLOAD LOGO PRÊMIO:',
        error,
      )

      message.error(
        error?.response?.data?.message ||
        error?.message ||
        'Erro ao enviar logo da página do prêmio',
      )

      onError(error)
    } finally {
      setUploadingPrizePageLogo(false)
    }
  }

  const uploadPrizePageFrame = async ({
    file,
    onSuccess,
    onError,
  }) => {
    try {
      setUploadingPrizePageFrame(true)

      if (!gameId) {
        throw new Error(
          'Selecione um jogo antes de enviar a imagem',
        )
      }

      const response =
        await UploadService.image(file)

      const data =
        response?.data || response

      if (!data?.url) {
        throw new Error(
          'A API não retornou a URL da imagem',
        )
      }

      form.setFieldsValue({
        prizePageFrameUrl:
          data.url,
      })

      await api.patch(
        `/games/${gameId}`,
        {
          prizePageFrameUrl:
            data.url,
        },
      )

      setGames((currentGames) =>
        currentGames.map((game) =>
          game.id === gameId
            ? {
              ...game,
              prizePageFrameUrl:
                data.url,
            }
            : game,
        ),
      )

      message.success(
        'Moldura enviada e salva',
      )

      onSuccess(data)
    } catch (error) {
      console.error(
        'ERRO UPLOAD MOLDURA:',
        error,
      )

      message.error(
        error?.response?.data?.message ||
        error?.message ||
        'Erro ao enviar moldura',
      )

      onError(error)
    } finally {
      setUploadingPrizePageFrame(false)
    }
  }

  const uploadFormPageBackground = async ({
    file,
    onSuccess,
    onError,
  }) => {
    try {
      setUploadingFormPageBackground(true)

      const response =
        await UploadService.image(file)

      const data =
        response?.data || response

      form.setFieldsValue({
        formPageBackgroundUrl:
          data.url,
      })

      message.success(
        'Fundo do formulário enviado',
      )

      onSuccess(data)
    } catch (error) {
      console.error(
        'ERRO UPLOAD FUNDO FORMULÁRIO:',
        error,
      )

      message.error(
        'Erro ao enviar fundo do formulário',
      )

      onError(error)
    } finally {
      setUploadingFormPageBackground(false)
    }
  }

  const uploadFormPageLogo = async ({
    file,
    onSuccess,
    onError,
  }) => {
    try {
      setUploadingFormPageLogo(true)

      const response =
        await UploadService.image(file)

      const data =
        response?.data || response

      form.setFieldsValue({
        formPageLogoUrl:
          data.url,
      })

      message.success(
        'Logo do formulário enviada',
      )

      onSuccess(data)
    } catch (error) {
      console.error(
        'ERRO UPLOAD LOGO FORMULÁRIO:',
        error,
      )

      message.error(
        'Erro ao enviar logo do formulário',
      )

      onError(error)
    } finally {
      setUploadingFormPageLogo(false)
    }
  }

  const uploadIdleBackground = async ({
    file,
    onSuccess,
    onError,
  }) => {
    try {
      setUploadingIdleBackground(true)

      if (!gameId) {
        throw new Error(
          'Selecione um jogo antes de enviar a imagem',
        )
      }

      const response =
        await UploadService.image(file)

      const data =
        response?.data || response

      if (!data?.url) {
        throw new Error(
          'A API não retornou a URL da imagem',
        )
      }

      form.setFieldsValue({
        idleScreenBackgroundUrl:
          data.url,
      })

      await api.patch(
        `/games/${gameId}`,
        {
          idleScreenBackgroundUrl:
            data.url,
        },
      )

      setGames((currentGames) =>
        currentGames.map((game) =>
          game.id === gameId
            ? {
              ...game,
              idleScreenBackgroundUrl:
                data.url,
            }
            : game,
        ),
      )

      message.success(
        'Imagem da tela de espera enviada e salva',
      )

      onSuccess(data)
    } catch (error) {
      console.error(
        'ERRO UPLOAD FUNDO TELA DE ESPERA:',
        error,
      )

      message.error(
        error?.response?.data?.message ||
        error?.message ||
        'Erro ao enviar imagem da tela de espera',
      )

      onError(error)
    } finally {
      setUploadingIdleBackground(false)
    }
  }

  const uploadIdleVideo = async ({
    file,
    onSuccess,
    onError,
  }) => {
    try {
      setUploadingIdleVideo(true)

      if (!gameId) {
        throw new Error(
          'Selecione um jogo antes de enviar o vídeo',
        )
      }

      const response =
        await UploadService.video(file)

      const data =
        response?.data || response

      if (!data?.url) {
        throw new Error(
          'A API não retornou a URL do vídeo',
        )
      }

      form.setFieldsValue({
        idleScreenVideoUrl:
          data.url,
      })

      await api.patch(
        `/games/${gameId}`,
        {
          idleScreenVideoUrl:
            data.url,
        },
      )

      setGames((currentGames) =>
        currentGames.map((game) =>
          game.id === gameId
            ? {
              ...game,
              idleScreenVideoUrl:
                data.url,
            }
            : game,
        ),
      )

      message.success(
        'Vídeo da tela de espera enviado e salvo',
      )

      onSuccess(data)
    } catch (error) {
      console.error(
        'ERRO UPLOAD VÍDEO TELA DE ESPERA:',
        error,
      )

      message.error(
        error?.response?.data?.message ||
        error?.message ||
        'Erro ao enviar vídeo da tela de espera',
      )

      onError(error)
    } finally {
      setUploadingIdleVideo(false)
    }
  }

  const loadGames = async () => {
    console.log('LOAD GAMES')

    try {
      const response = await api.get('/games')
      const data = response?.data || response
      const list = Array.isArray(data) ? data : []

      setGames(list)

      if (!list.length) {
        setGameId(undefined)
        form.resetFields()
        return
      }

      const selectedGame =
        list.find((item) => item.id === gameId) ||
        list[0]

      const normalizedGame =
        normalizeGameSettings(selectedGame)

      setGameId(selectedGame.id)


      form.setFieldsValue(normalizedGame)
    } catch (error) {
      console.error(
        'ERRO AO CARREGAR JOGOS:',
        error,
      )

      message.error(
        error?.response?.data?.message ||
        'Erro ao carregar jogos',
      )
    }
  }

  const handleSelectGame = (id) => {
    const selected =
      games.find(
        (item) => item.id === id,
      )

    if (!selected) {
      return
    }

    setGameId(id)

    /*
     * Limpa valores do jogo anterior antes
     * de inserir os valores do novo jogo.
     */
    form.resetFields()

    form.setFieldsValue(
      normalizeGameSettings(selected),
    )
  }

  const saveSettings = async (submittedValues) => {
    const allValues = {
      ...form.getFieldsValue(true),
      ...submittedValues,
    }

    if (!gameId) {
      message.error('Selecione um jogo')
      return
    }

    const {
      id,
      event,
      prizes,
      _count,
      userAccesses,
      participants,
      spins,
      leadForms,
      leads,
      createdAt,
      updatedAt,
      ...values
    } = allValues

    setLoading(true)

    try {
      const payload = {
        ...values,

        spinDuration: Number(
          values.spinDuration || 5000,
        ),

        logoSize: Number(
          values.logoSize || 130,
        ),

        wheelSize: Number(
          values.wheelSize || 680,
        ),

        titleFontSize: Number(
          values.titleFontSize || 48,
        ),

        subtitleFontSize: Number(
          values.subtitleFontSize || 20,
        ),

        playHintFontSize: Number(
          values.playHintFontSize || 18,
        ),

        topBenefitsBorderRadius: Number(
          values.topBenefitsBorderRadius || 18,
        ),

        topBenefitsPadding: Number(
          values.topBenefitsPadding || 16,
        ),

        topBenefitsGap: Number(
          values.topBenefitsGap || 24,
        ),

        bottomBannerBorderRadius: Number(
          values.bottomBannerBorderRadius || 18,
        ),

        bottomBannerPadding: Number(
          values.bottomBannerPadding || 16,
        ),

        prizePageReturnDelay: Number(
          values.prizePageReturnDelay || 8000,
        ),

        // ==========================================
        // REDIRECIONAMENTO EXTERNO
        // ==========================================

        externalRedirectEnabled:
          values.externalRedirectEnabled ??
          false,

        externalRedirectUrl:
          values.externalRedirectUrl
            ? String(
              values.externalRedirectUrl,
            ).trim()
            : null,

        externalRedirectMode:
          values.externalRedirectMode ||
          'BUTTON',

        externalRedirectButtonText:
          values.externalRedirectButtonText ||
          'Continuar',

        participationLimitMinutes:
          values.participationLimitType ===
            'MINUTES'
            ? Number(
              values.participationLimitMinutes ||
              60,
            )
            : null,

        prizePageTitleFontSize: Number(
          values.prizePageTitleFontSize || 76,
        ),

        prizePageTitleFontWeight:
          values.prizePageTitleFontWeight,

        prizePageTitleSpacing: Number(
          values.prizePageTitleSpacing ?? 24,
        ),

        prizePageSubtitleFontSize: Number(
          values.prizePageSubtitleFontSize || 48,
        ),

        prizePageSubtitleFontWeight:
          values.prizePageSubtitleFontWeight,

        prizePageSubtitleSpacing: Number(
          values.prizePageSubtitleSpacing ?? 14,
        ),

        prizePagePrizeNameFontSize: Number(
          values.prizePagePrizeNameFontSize || 84,
        ),

        prizePagePrizeNameFontWeight:
          values.prizePagePrizeNameFontWeight,

        prizePagePrizeTextTransform:
          values.prizePagePrizeTextTransform,

        formPageLogoSize: Number(
          values.formPageLogoSize || 180,
        ),

        formPageOverlayOpacity: Number(
          values.formPageOverlayOpacity ?? 0,
        ),

        formPageBackgroundBlur: Number(
          values.formPageBackgroundBlur ?? 0,
        ),

        formPageTitleFontSize: Number(
          values.formPageTitleFontSize || 32,
        ),

        formPageSubtitleFontSize: Number(
          values.formPageSubtitleFontSize ||
          16,
        ),

        formPageCardOpacity: Number(
          values.formPageCardOpacity ?? 96,
        ),

        formPageCardBorderWidth: Number(
          values.formPageCardBorderWidth ?? 1,
        ),

        formPageCardBorderRadius: Number(
          values.formPageCardBorderRadius ||
          24,
        ),

        formPageCardWidth: Number(
          values.formPageCardWidth || 560,
        ),

        formPageCardPadding: Number(
          values.formPageCardPadding || 32,
        ),

        formPageCardPosition:
          values.formPageCardPosition,

        formPageLabelColor:
          values.formPageLabelColor,

        formPageLabelFontSize: Number(
          values.formPageLabelFontSize || 14,
        ),

        formPageLabelFontWeight:
          values.formPageLabelFontWeight,

        formPageInputBackground:
          values.formPageInputBackground,

        formPageInputTextColor:
          values.formPageInputTextColor,

        formPageInputPlaceholderColor:
          values.formPageInputPlaceholderColor,

        formPageInputBorderColor:
          values.formPageInputBorderColor,

        formPageInputFocusColor:
          values.formPageInputFocusColor,

        formPageInputFontSize: Number(
          values.formPageInputFontSize || 16,
        ),

        formPageInputBorderRadius: Number(
          values.formPageInputBorderRadius ||
          8,
        ),

        formPageInputHeight: Number(
          values.formPageInputHeight || 44,
        ),

        formPageButtonHeight: Number(
          values.formPageButtonHeight || 54,
        ),

        formPageButtonBorderRadius: Number(
          values.formPageButtonBorderRadius ||
          10,
        ),


        // ==========================================
        // TELA DE ESPERA
        // ==========================================

        idleScreenEnabled:
          values.idleScreenEnabled ??
          false,

        idleScreenDelay:
          Number(
            values.idleScreenDelay ||
            30000,
          ),

        idleScreenShowBackground:
          values.idleScreenShowBackground ??
          true,

        idleScreenBackgroundUrl:
          values.idleScreenBackgroundUrl ||
          null,

        idleScreenShowVideo:
          values.idleScreenShowVideo ??
          false,

        idleScreenVideoUrl:
          values.idleScreenVideoUrl ||
          null,

        idleScreenMessage:
          values.idleScreenMessage ||
          'Toque na tela para começar',

        idleScreenMessageColor:
          values.idleScreenMessageColor ||
          '#ffffff',

        idleScreenMessageFontSize:
          Number(
            values.idleScreenMessageFontSize ||
            48,
          ),

        idleScreenMessagePosition:
          values.idleScreenMessagePosition ||
          'CENTER',

        idleScreenOverlayColor:
          values.idleScreenOverlayColor ||
          '#000000',

        idleScreenOverlayOpacity:
          Number(
            values.idleScreenOverlayOpacity ??
            20,
          ),
      }

      console.log(
        'PAYLOAD LIMPO:',
        payload,
      )

      await api.patch(
        `/games/${gameId}`,
        payload,
      )

      message.success(
        'Configurações salvas',
      )

      await loadGames()
    } catch (error) {
      console.error(
        'ERRO AO SALVAR CONFIGURAÇÕES:',
        error?.response?.data || error,
      )

      message.error(
        error?.response?.data?.message ||
        'Erro ao salvar configurações',
      )
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadGames()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Space style={{ width: '100%', justifyContent: 'space-between', marginBottom: 16 }}>
        <div>
          <Title level={2} style={{ margin: 0 }}>
            Configurações do Game
          </Title>
          <p>Personalize layout, visual, textos e elementos da tela.</p>
        </div>

        <Button type="primary" loading={loading} onClick={() => form.submit()}>
          Salvar Configurações
        </Button>
      </Space>

      <Card style={{ marginBottom: 16 }}>
        <Select
          style={{ width: 420, maxWidth: '100%' }}
          placeholder="Selecione o jogo"
          value={gameId}
          onChange={handleSelectGame}
          showSearch
          optionFilterProp="children"
        >
          {games.map((game) => (
            <Select.Option key={game.id} value={game.id}>
              {game.name} {game.event?.name ? `- ${game.event.name}` : ''}
            </Select.Option>
          ))}
        </Select>
      </Card>

      <Form
        layout="vertical"
        form={form}
        onFinish={saveSettings}
        initialValues={normalizeGameSettings({})}
      >
        <Tabs
          defaultActiveKey="game"
          destroyInactiveTabPane={false}
          items={[
            {
              key: 'game',
              label: 'Roleta',
              children: (
                <>
                  <Card title="Elementos da Tela" style={{ marginBottom: 24 }}>
                    <Space wrap size="large">
                      <Form.Item name="showLogo" label="Mostrar Logo" valuePropName="checked">
                        <Switch />
                      </Form.Item>

                      <Form.Item name="showTitle" label="Mostrar Título" valuePropName="checked">
                        <Switch />
                      </Form.Item>

                      <Form.Item name="showSubtitle" label="Mostrar Subtítulo" valuePropName="checked">
                        <Switch />
                      </Form.Item>

                      <Form.Item name="showPlayHint" label="Mostrar Texto de Dica" valuePropName="checked">
                        <Switch />
                      </Form.Item>

                      <Form.Item
                        name="showTopBenefits"
                        label="Mostrar Faixa de Benefícios"
                        valuePropName="checked"
                      >
                        <Switch />
                      </Form.Item>

                      <Form.Item
                        name="showBottomBanner"
                        label="Mostrar Banner Inferior"
                        valuePropName="checked"
                      >
                        <Switch />
                      </Form.Item>
                      <Form.Item
                        label="Exibir imagem do prêmio na tela de resultado"
                        name="showPrizeImage"
                        valuePropName="checked"
                      >
                        <Switch />

                      </Form.Item>
                      <Form.Item
                        name="disableContextMenu"
                        label="Desativar botão direito"
                        valuePropName="checked"
                      >
                        <Switch />
                      </Form.Item>

                      <Form.Item
                        name="fullscreenEnabled"
                        label="Usar tela cheia"
                        valuePropName="checked"
                      >
                        <Switch />
                      </Form.Item>
                    </Space>
                  </Card>

                  <Card
                    title="Campos do formulário"
                    style={{
                      marginBottom: 16,
                    }}
                  >
                    <Row gutter={16}>
                      <Col xs={24} md={8}>
                        <Form.Item
                          name="formPageLabelColor"
                          label="Cor dos nomes dos campos"
                        >
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item
                          name="formPageLabelFontSize"
                          label="Tamanho dos nomes"
                        >
                          <InputNumber
                            min={10}
                            max={40}
                            style={{
                              width: '100%',
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item
                          name="formPageLabelFontWeight"
                          label="Peso dos nomes"
                        >
                          <Select
                            options={[
                              {
                                label: 'Normal',
                                value: '400',
                              },
                              {
                                label: 'Seminegrito',
                                value: '600',
                              },
                              {
                                label: 'Negrito',
                                value: '700',
                              },
                              {
                                label: 'Extra negrito',
                                value: '900',
                              },
                            ]}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item
                          name="formPageInputBackground"
                          label="Fundo dos campos"
                        >
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item
                          name="formPageInputTextColor"
                          label="Cor do texto digitado"
                        >
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item
                          name="formPageInputPlaceholderColor"
                          label="Cor do placeholder"
                        >
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item
                          name="formPageInputBorderColor"
                          label="Cor da borda"
                        >
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item
                          name="formPageInputFocusColor"
                          label="Cor da borda selecionada"
                        >
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item
                          name="formPageInputFontSize"
                          label="Tamanho do texto digitado"
                        >
                          <InputNumber
                            min={10}
                            max={40}
                            style={{
                              width: '100%',
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item
                          name="formPageInputHeight"
                          label="Altura dos campos"
                        >
                          <InputNumber
                            min={32}
                            max={100}
                            style={{
                              width: '100%',
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item
                          name="formPageInputBorderRadius"
                          label="Arredondamento"
                        >
                          <InputNumber
                            min={0}
                            max={60}
                            style={{
                              width: '100%',
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item
                          name="formPageConsentTextColor"
                          label="Cor do texto LGPD"
                        >
                          <Input type="color" />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>

                  <Card title="Layout da Roleta" style={{ marginBottom: 24 }}>
                    <Row gutter={16}>
                      <Col xs={24} md={8}>
                        <Form.Item name="layoutOrientation" label="Orientação do Totem">
                          <Select
                            options={[
                              { label: 'Automático', value: 'AUTO' },
                              { label: 'Vertical / Portrait', value: 'PORTRAIT' },
                              { label: 'Horizontal / Landscape', value: 'LANDSCAPE' },
                            ]}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item name="layoutMode" label="Modelo do Layout">
                          <Select
                            options={[
                              { label: 'Centralizado', value: 'CENTER' },
                              { label: 'Tela cheia', value: 'FULLSCREEN' },
                              { label: 'Banner lateral', value: 'SIDE_BANNER' },
                            ]}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item name="wheelModel" label="Modelo da Roleta">
                          <Select
                            options={[
                              { label: 'Modelo 1 - Cassino Neon', value: 'MODEL_1' },
                              { label: 'Modelo 2 - Clássica Dourada', value: 'MODEL_2' },
                              { label: 'Modelo 3 - Minimalista', value: 'MODEL_3' },
                              { label: 'Modelo 4 - Premium LED', value: 'MODEL_4' },
                              { label: 'Modelo 5 - Retrô Vegas', value: 'MODEL_5' },
                              { label: 'Modelo 6 - Futurista', value: 'MODEL_6' },
                              { label: 'Modelo 7 - Cassino Clássico', value: 'MODEL_7' },
                            ]}
                          />
                        </Form.Item>

                        <Form.Item shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const model = getFieldValue('wheelModel') || 'MODEL_1'

                            return (
                              <div
                                style={{
                                  marginTop: -10,
                                  padding: 12,
                                  borderRadius: 12,
                                  background: '#fafafa',
                                  border: '1px solid #e8e8e8',
                                }}
                              >
                                <strong>{model}</strong>
                                <br />
                                {wheelModelDescriptions[model]}
                              </div>
                            )
                          }}
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={12}>
                        <Form.Item name="wheelPosition" label="Posição da Roleta">
                          <Select
                            options={[
                              { label: 'Topo', value: 'TOP' },
                              { label: 'Meio', value: 'CENTER' },
                              { label: 'Baixo', value: 'BOTTOM' },
                            ]}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={12}>
                        <Form.Item name="wheelSize" label="Tamanho da Roleta em pixels">
                          <InputNumber min={300} max={1100} style={{ width: '100%' }} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>

                  <Card title="Visual do Game" style={{ marginBottom: 24 }}>
                    <Form.Item name="name" label="Nome interno do jogo">
                      <Input placeholder="Ex: Roleta BGS 2026" />
                    </Form.Item>

                    <Row gutter={16}>
                      <Col xs={24} md={8}>
                        <Form.Item name="primaryColor" label="Cor primária">
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item name="secondaryColor" label="Cor secundária">
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item name="backgroundColor" label="Cor de fundo">
                          <Input type="color" />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Divider />

                    <Row gutter={16}>
                      <Col xs={24} md={12}>
                        <Form.Item name="logoUrl" label="Logo">
                          <Input placeholder="URL da logo ou envie abaixo" />
                        </Form.Item>

                        <Upload
                          customRequest={uploadLogo}
                          showUploadList={false}
                          accept=".png,.jpg,.jpeg,.webp"
                        >
                          <Button icon={<UploadOutlined />} loading={uploadingLogo}>
                            Enviar logo
                          </Button>
                        </Upload>

                        <Form.Item shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const logoUrl = getFieldValue('logoUrl')

                            return logoUrl ? (
                              <div style={{ marginTop: 16 }}>
                                <Image
                                  src={getImageUrl(logoUrl)}
                                  height={80}
                                  style={{
                                    objectFit: 'contain',
                                    background: '#f5f5f5',
                                    borderRadius: 12,
                                    padding: 8,
                                  }}
                                />
                              </div>
                            ) : null
                          }}
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={12}>
                        <Form.Item name="backgroundUrl" label="Imagem de fundo">
                          <Input placeholder="URL do fundo ou envie abaixo" />
                        </Form.Item>

                        <Upload
                          customRequest={uploadBackground}
                          showUploadList={false}
                          accept=".png,.jpg,.jpeg,.webp"
                        >
                          <Button icon={<UploadOutlined />} loading={uploadingBackground}>
                            Enviar fundo
                          </Button>
                        </Upload>

                        <Form.Item shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const backgroundUrl = getFieldValue('backgroundUrl')

                            return backgroundUrl ? (
                              <div style={{ marginTop: 16 }}>
                                <Image
                                  src={getImageUrl(backgroundUrl)}
                                  height={110}
                                  style={{
                                    objectFit: 'cover',
                                    borderRadius: 12,
                                  }}
                                />
                              </div>
                            ) : null
                          }}
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16} style={{ marginTop: 16 }}>
                      <Col xs={24} md={8}>
                        <Form.Item name="logoVerticalPosition" label="Posição vertical da logo">
                          <Select
                            options={[
                              { label: 'Topo', value: 'TOP' },
                              { label: 'Rodapé', value: 'BOTTOM' },
                            ]}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item name="logoHorizontalPosition" label="Alinhamento da logo">
                          <Select
                            options={[
                              { label: 'Esquerda', value: 'LEFT' },
                              { label: 'Centro', value: 'CENTER' },
                              { label: 'Direita', value: 'RIGHT' },
                            ]}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item name="logoSize" label="Tamanho da logo">
                          <InputNumber min={40} max={500} style={{ width: '100%' }} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>

                  <Card title="Título e Subtítulo" style={{ marginBottom: 24 }}>
                    <Form.Item name="title" label="Texto do Título">
                      <Input />
                    </Form.Item>

                    <Row gutter={16}>
                      <Col xs={24} md={8}>
                        <Form.Item name="titleColor" label="Cor do Título">
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item name="titleFontSize" label="Tamanho do Título">
                          <InputNumber min={10} max={120} style={{ width: '100%' }} />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item name="titleFontWeight" label="Peso do Título">
                          <Select
                            options={[
                              { label: 'Normal', value: '400' },
                              { label: 'Bold', value: '700' },
                              { label: 'Extra Bold', value: '900' },
                              { label: 'Black', value: '950' },
                            ]}
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Divider />

                    <Form.Item name="subtitle" label="Texto do Subtítulo">
                      <Input />
                    </Form.Item>

                    <Row gutter={16}>
                      <Col xs={24} md={8}>
                        <Form.Item name="subtitleColor" label="Cor do Subtítulo">
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item name="subtitleFontSize" label="Tamanho do Subtítulo">
                          <InputNumber min={10} max={80} style={{ width: '100%' }} />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item name="subtitleFontWeight" label="Peso do Subtítulo">
                          <Select
                            options={[
                              { label: 'Normal', value: '400' },
                              { label: 'Bold', value: '700' },
                              { label: 'Extra Bold', value: '900' },
                            ]}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>

                  <Card title="Texto de Dica" style={{ marginBottom: 24 }}>
                    <Form.Item name="playHintText" label="Texto">
                      <Input />
                    </Form.Item>

                    <Row gutter={16}>
                      <Col xs={24} md={8}>
                        <Form.Item name="playHintColor" label="Cor">
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item name="playHintFontSize" label="Tamanho">
                          <InputNumber min={10} max={60} style={{ width: '100%' }} />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item name="playHintFontWeight" label="Peso">
                          <Select
                            options={[
                              { label: 'Normal', value: '400' },
                              { label: 'Bold', value: '700' },
                              { label: 'Extra Bold', value: '900' },
                            ]}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>

                  <Card title="Faixa de Benefícios" style={{ marginBottom: 24 }}>
                    <Form.Item name="topBenefitsTitle" label="Título da Faixa">
                      <Input placeholder="Opcional" />
                    </Form.Item>

                    <Form.List name="topBenefitsItems">
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map(({ key, name, ...restField }) => (
                            <Space key={key} align="baseline" style={{ display: 'flex', marginBottom: 8 }}>
                              <Form.Item
                                {...restField}
                                name={[name, 'icon']}
                                rules={[{ required: true }]}
                              >
                                <Input placeholder="🎁" style={{ width: 80 }} />
                              </Form.Item>

                              <Form.Item
                                {...restField}
                                name={[name, 'text']}
                                rules={[{ required: true }]}
                              >
                                <Input placeholder="Texto" style={{ width: 320 }} />
                              </Form.Item>

                              <Button danger icon={<DeleteOutlined />} onClick={() => remove(name)} />
                            </Space>
                          ))}

                          <Button
                            block
                            icon={<PlusOutlined />}
                            onClick={() => add({ icon: '🎁', text: 'Novo item' })}
                          >
                            Adicionar item
                          </Button>
                        </>
                      )}
                    </Form.List>

                    <Divider />

                    <Row gutter={16}>
                      <Col xs={24} md={8}>
                        <Form.Item name="topBenefitsBackground" label="Fundo">
                          <Input />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item name="topBenefitsBorderColor" label="Borda">
                          <Input />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item name="topBenefitsTextColor" label="Cor do Texto">
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item name="topBenefitsBorderRadius" label="Raio da Borda">
                          <InputNumber min={0} max={80} style={{ width: '100%' }} />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item name="topBenefitsPadding" label="Espaçamento Interno">
                          <InputNumber min={4} max={60} style={{ width: '100%' }} />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item name="topBenefitsGap" label="Espaço entre Itens">
                          <InputNumber min={4} max={80} style={{ width: '100%' }} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>

                  <Card title="Banner Inferior / LGPD" style={{ marginBottom: 24 }}>
                    <Form.Item name="bottomBannerIcon" label="Ícone">
                      <Input placeholder="🛡️" />
                    </Form.Item>

                    <Form.Item name="bottomBannerTitle" label="Título">
                      <Input />
                    </Form.Item>

                    <Form.Item name="bottomBannerSubtitle" label="Subtítulo">
                      <Input />
                    </Form.Item>

                    <Row gutter={16}>
                      <Col xs={24} md={8}>
                        <Form.Item name="bottomBannerBackground" label="Fundo">
                          <Input />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item name="bottomBannerBorderColor" label="Borda">
                          <Input />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item name="bottomBannerTextColor" label="Cor do Texto">
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={12}>
                        <Form.Item name="bottomBannerBorderRadius" label="Raio da Borda">
                          <InputNumber min={0} max={80} style={{ width: '100%' }} />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={12}>
                        <Form.Item name="bottomBannerPadding" label="Espaçamento Interno">
                          <InputNumber min={4} max={60} style={{ width: '100%' }} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>

                  <Card title="Captação de Leads" style={{ marginBottom: 24 }}>
                    <Alert
                      showIcon
                      type="info"
                      style={{ marginBottom: 16 }}
                      message="Defina em qual momento o formulário ativo vinculado ao jogo será exibido."
                    />

                    <Form.Item
                      name="leadCapturePosition"
                      label="Quando exibir o formulário?"
                    >
                      <Select
                        options={[
                          {
                            value: 'BEFORE_GAME',
                            label: 'Antes da roleta',
                          },
                          {
                            value: 'AFTER_GAME',
                            label: 'Depois da tela do prêmio',
                          },
                        ]}
                      />
                    </Form.Item>

                    <Text type="secondary">
                      Em “Depois da tela do prêmio”, o participante joga primeiro,
                      vê o resultado e, ao continuar, é direcionado ao formulário ativo.
                    </Text>
                  </Card>

                  <Card title="Campos Obrigatórios" style={{ marginBottom: 24 }}>
                    <Space wrap size="large">
                      <Form.Item name="requireName" label="Exigir nome" valuePropName="checked">
                        <Switch />
                      </Form.Item>

                      <Form.Item name="requirePhone" label="Exigir telefone" valuePropName="checked">
                        <Switch />
                      </Form.Item>

                      <Form.Item name="requireEmail" label="Exigir e-mail" valuePropName="checked">
                        <Switch />
                      </Form.Item>

                      <Form.Item name="requireCpf" label="Exigir CPF" valuePropName="checked">
                        <Switch />
                      </Form.Item>
                    </Space>
                  </Card>

                  <Card title="Regras de Participação">
                    <Space wrap size="large">
                      <Form.Item
                        name="onePlayPerPhone"
                        label="Bloquear telefone repetido"
                        valuePropName="checked"
                      >
                        <Switch />
                      </Form.Item>

                      <Form.Item
                        name="onePlayPerEmail"
                        label="Bloquear e-mail repetido"
                        valuePropName="checked"
                      >
                        <Switch />
                      </Form.Item>

                      <Form.Item
                        name="onePlayPerCpf"
                        label="Bloquear CPF repetido"
                        valuePropName="checked"
                      >
                        <Switch />
                      </Form.Item>
                    </Space>

                    <Form.Item name="participationLimitType" label="Período da regra">
                      <Select
                        options={[
                          { label: 'Não bloquear repetição', value: 'NONE' },
                          { label: 'Por jogo inteiro', value: 'GAME' },
                          { label: 'Por dia', value: 'DAY' },
                          { label: 'Por hora', value: 'HOUR' },
                          { label: 'Após X minutos', value: 'MINUTES' },
                        ]}
                      />
                    </Form.Item>
                  </Card>
                </>
              ),
            },
            {
              key: 'form-page',
              label: 'Formulário',
              children: (
                <>
                  <Alert
                    showIcon
                    type="info"
                    style={{ marginBottom: 24 }}
                    message="Personalize completamente a tela do formulário."
                    description="Todas as configurações do formulário estão organizadas em seções."
                  />

                  <Card
                    title="Fundo da Tela"
                    style={{
                      marginBottom: 24,
                    }}
                  >
                    <Row gutter={[16, 16]}>
                      <Col xs={24} md={12}>
                        <Form.Item
                          name="formPageBackgroundUrl"
                          label="Imagem de fundo"
                        >
                          <Input placeholder="URL da imagem ou envie abaixo" />
                        </Form.Item>

                        <Upload
                          customRequest={
                            uploadFormPageBackground
                          }
                          showUploadList={false}
                          accept=".png,.jpg,.jpeg,.webp"
                        >
                          <Button
                            icon={<UploadOutlined />}
                            loading={
                              uploadingFormPageBackground
                            }
                          >
                            Enviar fundo
                          </Button>
                        </Upload>

                        <Form.Item
                          shouldUpdate
                          noStyle
                        >
                          {({
                            getFieldValue,
                          }) => {
                            const url =
                              getFieldValue(
                                'formPageBackgroundUrl',
                              )

                            return url ? (
                              <div
                                style={{
                                  marginTop: 16,
                                }}
                              >
                                <Image
                                  src={getImageUrl(
                                    url,
                                  )}
                                  height={140}
                                  style={{
                                    width: '100%',
                                    objectFit:
                                      'cover',
                                    borderRadius:
                                      12,
                                  }}
                                />
                              </div>
                            ) : null
                          }}
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={12}>
                        <Row gutter={16}>
                          <Col xs={24} md={12}>
                            <Form.Item
                              name="formPageOverlayColor"
                              label="Cor da camada"
                            >
                              <Input type="color" />
                            </Form.Item>
                          </Col>

                          <Col xs={24} md={12}>
                            <Form.Item
                              name="formPageOverlayOpacity"
                              label="Opacidade da camada (%)"
                            >
                              <InputNumber
                                min={0}
                                max={100}
                                style={{
                                  width:
                                    '100%',
                                }}
                              />
                            </Form.Item>
                          </Col>
                        </Row>

                        <Alert
                          type="info"
                          showIcon
                          message="A camada melhora a leitura do formulário sobre imagens claras ou detalhadas."
                        />
                      </Col>
                    </Row>
                  </Card>

                  <Card
                    title="Logo do Formulário"
                    style={{
                      marginBottom: 24,
                    }}
                  >
                    <Form.Item
                      name="formPageShowLogo"
                      label="Mostrar logo"
                      valuePropName="checked"
                    >
                      <Switch />
                    </Form.Item>

                    <Row gutter={[16, 16]}>
                      <Col xs={24} md={12}>
                        <Form.Item
                          name="formPageLogoUrl"
                          label="Logo específica"
                          extra="Deixe vazio para não usar uma logo específica."
                        >
                          <Input placeholder="URL da logo ou envie abaixo" />
                        </Form.Item>

                        <Upload
                          customRequest={
                            uploadFormPageLogo
                          }
                          showUploadList={false}
                          accept=".png,.jpg,.jpeg,.webp"
                        >
                          <Button
                            icon={<UploadOutlined />}
                            loading={
                              uploadingFormPageLogo
                            }
                          >
                            Enviar logo
                          </Button>
                        </Upload>

                        <Form.Item
                          shouldUpdate
                          noStyle
                        >
                          {({
                            getFieldValue,
                          }) => {
                            const url =
                              getFieldValue(
                                'formPageLogoUrl',
                              )

                            return url ? (
                              <div
                                style={{
                                  marginTop: 16,
                                }}
                              >
                                <Image
                                  src={getImageUrl(
                                    url,
                                  )}
                                  height={90}
                                  style={{
                                    objectFit:
                                      'contain',
                                    background:
                                      '#f5f5f5',
                                    borderRadius:
                                      12,
                                    padding: 10,
                                  }}
                                />
                              </div>
                            ) : null
                          }}
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={12}>
                        <Row gutter={16}>
                          <Col xs={24} md={12}>
                            <Form.Item
                              name="formPageLogoVerticalPosition"
                              label="Posição vertical"
                            >
                              <Select
                                options={[
                                  {
                                    label:
                                      'Topo',
                                    value:
                                      'TOP',
                                  },
                                  {
                                    label:
                                      'Rodapé',
                                    value:
                                      'BOTTOM',
                                  },
                                ]}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} md={12}>
                            <Form.Item
                              name="formPageLogoHorizontalPosition"
                              label="Alinhamento"
                            >
                              <Select
                                options={[
                                  {
                                    label:
                                      'Esquerda',
                                    value:
                                      'LEFT',
                                  },
                                  {
                                    label:
                                      'Centro',
                                    value:
                                      'CENTER',
                                  },
                                  {
                                    label:
                                      'Direita',
                                    value:
                                      'RIGHT',
                                  },
                                ]}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24}>
                            <Form.Item
                              name="formPageLogoSize"
                              label="Tamanho da logo"
                            >
                              <InputNumber
                                min={40}
                                max={600}
                                style={{
                                  width:
                                    '100%',
                                }}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Card>

                  <Card
                    title="Card do Formulário"
                    style={{
                      marginBottom: 24,
                    }}
                  >
                    <Row gutter={16}>
                      <Col xs={24} md={8}>
                        <Form.Item
                          name="formPageCardBackground"
                          label="Fundo do card"
                          extra="Pode usar hexadecimal, rgb ou rgba."
                        >
                          <Input placeholder="rgba(15,15,15,.80)" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item
                          name="formPageCardBorderColor"
                          label="Cor da borda"
                          extra="Pode usar hexadecimal, rgb ou rgba."
                        >
                          <Input placeholder="rgba(255,255,255,.10)" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={4}>
                        <Form.Item
                          name="formPageCardBorderRadius"
                          label="Arredondamento"
                        >
                          <InputNumber
                            min={0}
                            max={100}
                            style={{
                              width:
                                '100%',
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={4}>
                        <Form.Item
                          name="formPageCardPadding"
                          label="Espaçamento"
                        >
                          <InputNumber
                            min={8}
                            max={100}
                            style={{
                              width:
                                '100%',
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={8}>
                        <Form.Item
                          name="formPageCardPosition"
                          label="Posição do card"
                        >
                          <Select
                            options={[
                              {
                                label: 'Topo',
                                value: 'TOP',
                              },
                              {
                                label: 'Centro',
                                value: 'CENTER',
                              },
                              {
                                label: 'Rodapé',
                                value: 'BOTTOM',
                              },
                            ]}
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Divider />

                    <Row gutter={16}>
                      <Col xs={24} md={6}>
                        <Form.Item
                          name="formPageTitleColor"
                          label="Cor do título"
                        >
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={6}>
                        <Form.Item
                          name="formPageSubtitleColor"
                          label="Cor do subtítulo"
                        >
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={6}>
                        <Form.Item
                          name="formPageButtonColor"
                          label="Cor do botão"
                        >
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={6}>
                        <Form.Item
                          name="formPageButtonTextColor"
                          label="Texto do botão"
                        >
                          <Input type="color" />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                  <Card
                    title="Campos do Formulário"
                    style={{ marginTop: 24 }}
                  >
                    <Row gutter={16}>
                      <Col span={6}>
                        <Form.Item
                          name="formPageLabelColor"
                          label="Cor dos títulos"
                        >
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col span={6}>
                        <Form.Item
                          name="formPageLabelFontSize"
                          label="Tamanho"
                        >
                          <InputNumber
                            min={10}
                            max={40}
                            style={{ width: '100%' }}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={6}>
                        <Form.Item
                          name="formPageLabelFontWeight"
                          label="Peso"
                        >
                          <Select
                            options={[
                              { value: '400', label: 'Normal' },
                              { value: '500', label: '500' },
                              { value: '600', label: '600' },
                              { value: '700', label: 'Bold' },
                              { value: '800', label: '800' },
                            ]}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={6}>
                        <Form.Item
                          name="formPageInputPlaceholderColor"
                          label="Placeholder"
                        >
                          <Input type="color" />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Divider />

                    <Row gutter={16}>
                      <Col span={6}>
                        <Form.Item
                          name="formPageInputBackground"
                          label="Fundo Input"
                        >
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col span={6}>
                        <Form.Item
                          name="formPageInputTextColor"
                          label="Texto Input"
                        >
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col span={6}>
                        <Form.Item
                          name="formPageInputBorderColor"
                          label="Cor da borda"
                        >
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col span={6}>
                        <Form.Item
                          name="formPageInputBorderRadius"
                          label="Arredondamento"
                        >
                          <InputNumber
                            style={{ width: '100%' }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={16}>
                      <Col span={6}>
                        <Form.Item
                          name="formPageInputHeight"
                          label="Altura"
                        >
                          <InputNumber
                            style={{ width: '100%' }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>

                  <Card title="Preview do Formulário">
                    <Form.Item shouldUpdate noStyle>
                      {({ getFieldValue }) => {
                        const background =
                          getFieldValue(
                            'formPageBackgroundUrl',
                          )

                        const backgroundColor =
                          getFieldValue(
                            'formPageBackgroundColor',
                          ) || '#15112f'

                        const overlayColor =
                          getFieldValue(
                            'formPageOverlayColor',
                          ) || '#000000'

                        const overlayOpacity =
                          Number(
                            getFieldValue(
                              'formPageOverlayOpacity',
                            ) ?? 45,
                          ) / 100

                        const showLogo =
                          getFieldValue(
                            'formPageShowLogo',
                          ) !== false

                        const formLogo =
                          getFieldValue(
                            'formPageLogoUrl',
                          )

                        const logoSize =
                          Number(
                            getFieldValue(
                              'formPageLogoSize',
                            ) || 180,
                          )

                        const logoHorizontalPosition =
                          getFieldValue(
                            'formPageLogoHorizontalPosition',
                          ) || 'CENTER'

                        const cardBackground =
                          getFieldValue(
                            'formPageCardBackground',
                          ) ||
                          'rgba(15,15,15,.80)'

                        const cardBorderColor =
                          getFieldValue(
                            'formPageCardBorderColor',
                          ) ||
                          'rgba(255,255,255,.10)'

                        const cardBorderWidth =
                          Number(
                            getFieldValue(
                              'formPageCardBorderWidth',
                            ) ?? 1,
                          )

                        const cardBorderRadius =
                          Number(
                            getFieldValue(
                              'formPageCardBorderRadius',
                            ) || 24,
                          )

                        const cardPadding =
                          Number(
                            getFieldValue(
                              'formPageCardPadding',
                            ) || 32,
                          )

                        const cardWidth =
                          Number(
                            getFieldValue(
                              'formPageCardWidth',
                            ) || 560,
                          )

                        const cardPosition =
                          getFieldValue(
                            'formPageCardPosition',
                          ) || 'CENTER'

                        const previewAlignment =
                          cardPosition === 'TOP'
                            ? 'flex-start'
                            : cardPosition === 'BOTTOM'
                              ? 'flex-end'
                              : 'center'

                        const title =
                          getFieldValue(
                            'formPageTitle',
                          ) || 'Cadastre-se'

                        const titleColor =
                          getFieldValue(
                            'formPageTitleColor',
                          ) || '#ffffff'

                        const titleFontSize =
                          Number(
                            getFieldValue(
                              'formPageTitleFontSize',
                            ) || 32,
                          )

                        const titleFontWeight =
                          getFieldValue(
                            'formPageTitleFontWeight',
                          ) || '800'

                        const subtitle =
                          getFieldValue(
                            'formPageSubtitle',
                          ) ||
                          'Preencha seus dados para participar'

                        const subtitleColor =
                          getFieldValue(
                            'formPageSubtitleColor',
                          ) || '#cccccc'

                        const subtitleFontSize =
                          Number(
                            getFieldValue(
                              'formPageSubtitleFontSize',
                            ) || 16,
                          )

                        const subtitleFontWeight =
                          getFieldValue(
                            'formPageSubtitleFontWeight',
                          ) || '400'

                        const labelColor =
                          getFieldValue(
                            'formPageLabelColor',
                          ) || '#ffffff'

                        const labelFontSize =
                          Number(
                            getFieldValue(
                              'formPageLabelFontSize',
                            ) || 14,
                          )

                        const labelFontWeight =
                          getFieldValue(
                            'formPageLabelFontWeight',
                          ) || '700'

                        const inputBackground =
                          getFieldValue(
                            'formPageInputBackground',
                          ) || '#ffffff'

                        const inputTextColor =
                          getFieldValue(
                            'formPageInputTextColor',
                          ) || '#111827'

                        const inputPlaceholderColor =
                          getFieldValue(
                            'formPageInputPlaceholderColor',
                          ) || '#9ca3af'

                        const inputBorderColor =
                          getFieldValue(
                            'formPageInputBorderColor',
                          ) || '#d1d5db'

                        const inputBorderRadius =
                          Number(
                            getFieldValue(
                              'formPageInputBorderRadius',
                            ) || 8,
                          )

                        const inputHeight =
                          Number(
                            getFieldValue(
                              'formPageInputHeight',
                            ) || 44,
                          )

                        const inputFontSize =
                          Number(
                            getFieldValue(
                              'formPageInputFontSize',
                            ) || 16,
                          )

                        const consentTextColor =
                          getFieldValue(
                            'formPageConsentTextColor',
                          ) || '#cccccc'

                        const buttonText =
                          getFieldValue(
                            'formPageButtonText',
                          ) || 'Começar jogo'

                        const buttonColor =
                          getFieldValue(
                            'formPageButtonColor',
                          ) || '#7c3aed'

                        const buttonTextColor =
                          getFieldValue(
                            'formPageButtonTextColor',
                          ) || '#ffffff'

                        const buttonHeight =
                          Number(
                            getFieldValue(
                              'formPageButtonHeight',
                            ) || 54,
                          )

                        const buttonBorderRadius =
                          Number(
                            getFieldValue(
                              'formPageButtonBorderRadius',
                            ) || 10,
                          )

                        const hexToRgb = (color) => {
                          const normalized =
                            String(
                              color || '#000000',
                            )
                              .replace('#', '')
                              .trim()

                          if (normalized.length === 3) {
                            const expanded =
                              normalized
                                .split('')
                                .map(
                                  (character) =>
                                    `${character}${character}`,
                                )
                                .join('')

                            return hexToRgb(
                              `#${expanded}`,
                            )
                          }

                          if (
                            normalized.length !== 6
                          ) {
                            return '0, 0, 0'
                          }

                          const red =
                            parseInt(
                              normalized.substring(
                                0,
                                2,
                              ),
                              16,
                            )

                          const green =
                            parseInt(
                              normalized.substring(
                                2,
                                4,
                              ),
                              16,
                            )

                          const blue =
                            parseInt(
                              normalized.substring(
                                4,
                                6,
                              ),
                              16,
                            )

                          return `${red}, ${green}, ${blue}`
                        }

                        const logoJustifyContent =
                          logoHorizontalPosition ===
                            'LEFT'
                            ? 'flex-start'
                            : logoHorizontalPosition ===
                              'RIGHT'
                              ? 'flex-end'
                              : 'center'

                        return (
                          <div
                            style={{
                              position: 'relative',
                              width: '100%',
                              minHeight: 720,

                              borderRadius: 24,
                              overflow: 'hidden',

                              backgroundColor,

                              backgroundImage:
                                background
                                  ? `url(${getImageUrl(
                                    background,
                                  )})`
                                  : 'none',

                              backgroundPosition:
                                'center',

                              backgroundSize:
                                'cover',

                              backgroundRepeat:
                                'no-repeat',

                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',

                              justifyContent:
                                previewAlignment,

                              padding: 32,
                              boxSizing: 'border-box',
                            }}
                          >
                            <div
                              style={{
                                position: 'absolute',
                                inset: 0,

                                background:
                                  `rgba(${hexToRgb(
                                    overlayColor,
                                  )}, ${overlayOpacity})`,

                                pointerEvents: 'none',
                              }}
                            />

                            <div
                              style={{
                                position: 'relative',
                                zIndex: 2,

                                width: `min(100%, ${cardWidth}px)`,

                                padding:
                                  cardPadding,

                                boxSizing:
                                  'border-box',

                                borderRadius:
                                  cardBorderRadius,

                                background:
                                  cardBackground,

                                border:
                                  `${cardBorderWidth}px solid ${cardBorderColor}`,

                                boxShadow:
                                  '0 24px 80px rgba(0,0,0,.35)',
                              }}
                            >
                              {showLogo &&
                                formLogo && (
                                  <div
                                    style={{
                                      width: '100%',
                                      display: 'flex',

                                      justifyContent:
                                        logoJustifyContent,

                                      marginBottom: 24,
                                    }}
                                  >
                                    <img
                                      src={getImageUrl(
                                        formLogo,
                                      )}
                                      alt="Logo"
                                      style={{
                                        width:
                                          logoSize,

                                        maxWidth:
                                          '80%',

                                        maxHeight:
                                          logoSize,

                                        objectFit:
                                          'contain',
                                      }}
                                    />
                                  </div>
                                )}

                              <div
                                style={{
                                  color:
                                    titleColor,

                                  fontSize:
                                    titleFontSize,

                                  fontWeight:
                                    titleFontWeight,

                                  lineHeight:
                                    1,

                                  textAlign:
                                    'center',

                                  marginBottom:
                                    8,

                                  textTransform:
                                    'uppercase',
                                }}
                              >
                                {title}
                              </div>

                              <div
                                style={{
                                  color:
                                    subtitleColor,

                                  fontSize:
                                    subtitleFontSize,

                                  fontWeight:
                                    subtitleFontWeight,

                                  lineHeight:
                                    1,

                                  textAlign:
                                    'center',

                                  marginBottom:
                                    8,

                                  textTransform:
                                    'uppercase',
                                }}
                              >
                                {subtitle}
                              </div>

                              {[
                                {
                                  label: 'Nome',
                                  placeholder:
                                    'Digite seu nome',
                                },
                                {
                                  label: 'Telefone',
                                  placeholder:
                                    'Digite seu telefone',
                                },
                                {
                                  label: 'E-mail',
                                  placeholder:
                                    'Digite seu e-mail',
                                },
                                {
                                  label: 'Empresa',
                                  placeholder:
                                    'Digite sua empresa',
                                },
                              ].map((field) => (
                                <div
                                  key={field.label}
                                  style={{
                                    marginBottom:
                                      14,
                                  }}
                                >
                                  <div
                                    style={{
                                      color:
                                        labelColor,

                                      fontSize:
                                        labelFontSize,

                                      fontWeight:
                                        labelFontWeight,

                                      marginBottom:
                                        6,
                                    }}
                                  >
                                    {field.label}
                                  </div>

                                  <div
                                    style={{
                                      width: '100%',

                                      height:
                                        inputHeight,

                                      display:
                                        'flex',

                                      alignItems:
                                        'center',

                                      padding:
                                        '0 14px',

                                      boxSizing:
                                        'border-box',

                                      background:
                                        inputBackground,

                                      color:
                                        inputPlaceholderColor,

                                      border:
                                        `1px solid ${inputBorderColor}`,

                                      borderRadius:
                                        inputBorderRadius,

                                      fontSize:
                                        inputFontSize,
                                    }}
                                  >
                                    {field.placeholder}
                                  </div>
                                </div>
                              ))}

                              <div
                                style={{
                                  display: 'flex',
                                  alignItems:
                                    'flex-start',
                                  gap: 8,

                                  color:
                                    consentTextColor,

                                  marginTop:
                                    12,

                                  marginBottom:
                                    20,

                                  lineHeight:
                                    1.35,
                                }}
                              >
                                <span>☐</span>

                                <span>
                                  Autorizo o uso dos
                                  meus dados conforme a
                                  política de
                                  privacidade.
                                </span>
                              </div>

                              <button
                                type="button"
                                style={{
                                  width:
                                    '100%',

                                  height:
                                    buttonHeight,

                                  border:
                                    'none',

                                  borderRadius:
                                    buttonBorderRadius,

                                  background:
                                    buttonColor,

                                  color:
                                    buttonTextColor,

                                  fontSize:
                                    18,

                                  fontWeight:
                                    800,

                                  cursor:
                                    'default',
                                }}
                              >
                                {buttonText}
                              </button>

                              <div
                                style={{
                                  marginTop: 14,
                                  padding: 10,

                                  background:
                                    inputBackground,

                                  color:
                                    inputTextColor,

                                  border:
                                    `1px dashed ${inputBorderColor}`,

                                  borderRadius:
                                    inputBorderRadius,

                                  fontSize:
                                    inputFontSize,
                                }}
                              >
                                Exemplo de texto digitado
                              </div>
                            </div>
                          </div>
                        )
                      }}
                    </Form.Item>
                  </Card>
                </>
              ),
            },
            {
              key: 'prize-page',
              label: 'Página do Prêmio',
              children: (
                <>
                  {/* Início da página do prêmio */}

                  <Card title="Visual da Página do Prêmio" style={{ marginBottom: 24 }}>
                    <Row gutter={16}>
                      <Col xs={24} md={12}>
                        <Form.Item name="prizePageBackgroundUrl" label="Imagem de Fundo">
                          <Input placeholder="URL da imagem" />
                        </Form.Item>

                        <Upload
                          customRequest={uploadPrizePageBackground}
                          showUploadList={false}
                          accept=".png,.jpg,.jpeg,.webp"
                        >
                          <Button icon={<UploadOutlined />} loading={uploadingPrizePageBackground}>
                            Enviar Fundo
                          </Button>
                        </Upload>

                        <Form.Item shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const url = getFieldValue('prizePageBackgroundUrl')

                            return url ? (
                              <div style={{ marginTop: 16 }}>
                                <Image
                                  src={getImageUrl(url)}
                                  height={120}
                                  style={{
                                    width: '100%',
                                    objectFit: 'cover',
                                    borderRadius: 12,
                                  }}
                                />
                              </div>
                            ) : null
                          }}
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={12}>
                        <Form.Item name="prizePageLogoUrl" label="Logo">
                          <Input placeholder="URL da logo" />
                        </Form.Item>

                        <Upload
                          customRequest={uploadPrizePageLogo}
                          showUploadList={false}
                          accept=".png,.jpg,.jpeg,.webp"
                        >
                          <Button icon={<UploadOutlined />} loading={uploadingPrizePageLogo}>
                            Enviar Logo
                          </Button>
                        </Upload>

                        <Form.Item shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const url = getFieldValue('prizePageLogoUrl')

                            return url ? (
                              <div style={{ marginTop: 16 }}>
                                <Image
                                  src={getImageUrl(url)}
                                  height={90}
                                  style={{
                                    objectFit: 'contain',
                                    borderRadius: 12,
                                    background: '#fafafa',
                                    padding: 10,
                                  }}
                                />
                              </div>
                            ) : null
                          }}
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>

                  <Card title="Imagem do Prêmio" style={{ marginBottom: 24 }}>
                    <Alert
                      showIcon
                      type="info"
                      message="A imagem cadastrada no brinde será exibida automaticamente nesta área."
                      style={{ marginBottom: 20 }}
                    />

                    <Form.Item name="prizePageFrameUrl" label="Moldura PNG (Opcional)">
                      <Input placeholder="URL da moldura PNG" />
                    </Form.Item>

                    <Upload
                      customRequest={uploadPrizePageFrame}
                      showUploadList={false}
                      accept=".png,.webp"
                    >
                      <Button icon={<UploadOutlined />} loading={uploadingPrizePageFrame}>
                        Enviar Moldura
                      </Button>
                    </Upload>

                    <Form.Item shouldUpdate noStyle>
                      {({ getFieldValue }) => {
                        const url = getFieldValue('prizePageFrameUrl')

                        return url ? (
                          <div style={{ marginTop: 16 }}>
                            <Image
                              src={getImageUrl(url)}
                              height={180}
                              style={{
                                objectFit: 'contain',
                                borderRadius: 12,
                                background: '#fafafa',
                                padding: 10,
                              }}
                            />
                          </div>
                        ) : null
                      }}
                    </Form.Item>
                  </Card>

                  <Card
                    title="Textos"
                    style={{
                      marginBottom: 24,
                    }}
                  >
                    <Divider orientation="left">
                      Título — PARABÉNS
                    </Divider>

                    <Row gutter={16}>
                      <Col xs={24}>
                        <Form.Item
                          name="prizePageTitle"
                          label="Texto do título"
                        >
                          <Input />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={6}>
                        <Form.Item
                          name="prizePageTitleColor"
                          label="Cor do título"
                        >
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={6}>
                        <Form.Item
                          name="prizePageTitleFontSize"
                          label="Tamanho da fonte"
                        >
                          <InputNumber
                            min={20}
                            max={180}
                            style={{
                              width: '100%',
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={6}>
                        <Form.Item
                          name="prizePageTitleFontWeight"
                          label="Peso da fonte"
                        >
                          <Select
                            options={[
                              {
                                label: 'Normal',
                                value: '400',
                              },
                              {
                                label: 'Seminegrito',
                                value: '600',
                              },
                              {
                                label: 'Negrito',
                                value: '700',
                              },
                              {
                                label: 'Extra negrito',
                                value: '900',
                              },
                              {
                                label: 'Black',
                                value: '950',
                              },
                            ]}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={6}>
                        <Form.Item
                          name="prizePageTitleSpacing"
                          label="Espaço após o título"
                        >
                          <InputNumber
                            min={0}
                            max={100}
                            style={{
                              width: '100%',
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Divider orientation="left">
                      Subtítulo — VOCÊ GANHOU
                    </Divider>

                    <Row gutter={16}>
                      <Col xs={24}>
                        <Form.Item
                          name="prizePageSubtitle"
                          label="Texto do subtítulo"
                        >
                          <Input />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={6}>
                        <Form.Item
                          name="prizePageSubtitleColor"
                          label="Cor do subtítulo"
                        >
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={6}>
                        <Form.Item
                          name="prizePageSubtitleFontSize"
                          label="Tamanho da fonte"
                        >
                          <InputNumber
                            min={16}
                            max={140}
                            style={{
                              width: '100%',
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={6}>
                        <Form.Item
                          name="prizePageSubtitleFontWeight"
                          label="Peso da fonte"
                        >
                          <Select
                            options={[
                              {
                                label: 'Normal',
                                value: '400',
                              },
                              {
                                label: 'Seminegrito',
                                value: '600',
                              },
                              {
                                label: 'Negrito',
                                value: '700',
                              },
                              {
                                label: 'Extra negrito',
                                value: '900',
                              },
                              {
                                label: 'Black',
                                value: '950',
                              },
                            ]}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={6}>
                        <Form.Item
                          name="prizePageSubtitleSpacing"
                          label="Espaço após o subtítulo"
                        >
                          <InputNumber
                            min={0}
                            max={100}
                            style={{
                              width: '100%',
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Divider orientation="left">
                      Nome do Prêmio
                    </Divider>

                    <Row gutter={16}>
                      <Col xs={24} md={6}>
                        <Form.Item
                          name="prizePagePrizeNameColor"
                          label="Cor do nome do prêmio"
                        >
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={6}>
                        <Form.Item
                          name="prizePagePrizeNameFontSize"
                          label="Tamanho da fonte"
                        >
                          <InputNumber
                            min={20}
                            max={200}
                            style={{
                              width: '100%',
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={6}>
                        <Form.Item
                          name="prizePagePrizeNameFontWeight"
                          label="Peso da fonte"
                        >
                          <Select
                            options={[
                              {
                                label: 'Normal',
                                value: '400',
                              },
                              {
                                label: 'Seminegrito',
                                value: '600',
                              },
                              {
                                label: 'Negrito',
                                value: '700',
                              },
                              {
                                label: 'Extra negrito',
                                value: '900',
                              },
                              {
                                label: 'Black',
                                value: '950',
                              },
                            ]}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={6}>
                        <Form.Item
                          name="prizePagePrizeTextTransform"
                          label="Transformação"
                        >
                          <Select
                            options={[
                              {
                                label: 'Normal',
                                value: 'none',
                              },
                              {
                                label: 'MAIÚSCULAS',
                                value: 'uppercase',
                              },
                              {
                                label: 'minúsculas',
                                value: 'lowercase',
                              },
                              {
                                label: 'Primeira Letra',
                                value: 'capitalize',
                              },
                            ]}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>

                  <Card
                    title="Comportamento"
                    style={{ marginBottom: 24 }}
                  >
                    <Space wrap size="large">
                      <Form.Item
                        name="prizePageEnabled"
                        label="Ativar página do prêmio"
                        valuePropName="checked"
                      >
                        <Switch />
                      </Form.Item>

                      <Form.Item
                        name="prizePageShowPrizeImage"
                        label="Mostrar imagem do prêmio"
                        valuePropName="checked"
                      >
                        <Switch />
                      </Form.Item>

                      <Form.Item
                        name="prizePageAutoReturn"
                        label="Retornar automaticamente"
                        valuePropName="checked"
                      >
                        <Switch />
                      </Form.Item>

                      <Form.Item
                        name="prizePageReturnDelay"
                        label="Tempo para retorno (ms)"
                      >
                        <InputNumber
                          min={1000}
                          max={60000}
                          step={1000}
                          style={{ width: 180 }}
                        />
                      </Form.Item>
                    </Space>
                  </Card>


                  {/* ==========================================
    REDIRECIONAMENTO EXTERNO
========================================== */}

                  <Card
                    title="Redirecionamento após o resultado"
                    style={{ marginBottom: 24 }}
                  >
                    <Text type="secondary">
                      Configure um link externo para continuar o fluxo
                      após a tela de resultado.
                    </Text>

                    <Form.Item
                      name="externalRedirectEnabled"
                      label="Ativar redirecionamento externo"
                      valuePropName="checked"
                      style={{ marginTop: 20 }}
                    >
                      <Switch />
                    </Form.Item>

                    <Form.Item
                      noStyle
                      shouldUpdate={(previous, current) =>
                        previous.externalRedirectEnabled !==
                        current.externalRedirectEnabled
                      }
                    >
                      {({ getFieldValue }) => {
                        const enabled =
                          getFieldValue(
                            'externalRedirectEnabled',
                          )

                        if (!enabled) {
                          return null
                        }

                        return (
                          <>
                            <Form.Item
                              name="externalRedirectUrl"
                              label="Link externo"
                              rules={[
                                {
                                  required: true,
                                  message:
                                    'Informe o link de redirecionamento',
                                },
                                {
                                  type: 'url',
                                  message:
                                    'Informe uma URL válida, incluindo https://',
                                },
                              ]}
                            >
                              <Input
                                placeholder="https://www.exemplo.com.br"
                              />
                            </Form.Item>

                            <Form.Item
                              name="externalRedirectMode"
                              label="Comportamento"
                            >
                              <Select>
                                <Select.Option value="BUTTON">
                                  Redirecionar ao clicar no botão
                                </Select.Option>

                                <Select.Option value="AUTO">
                                  Redirecionar automaticamente
                                </Select.Option>
                              </Select>
                            </Form.Item>

                            <Form.Item
                              noStyle
                              shouldUpdate={(previous, current) =>
                                previous.externalRedirectMode !==
                                current.externalRedirectMode
                              }
                            >
                              {({ getFieldValue }) =>
                                getFieldValue(
                                  'externalRedirectMode',
                                ) === 'BUTTON' ? (
                                  <Form.Item
                                    name="externalRedirectButtonText"
                                    label="Texto do botão"
                                  >
                                    <Input
                                      placeholder="Continuar"
                                    />
                                  </Form.Item>
                                ) : null
                              }
                            </Form.Item>
                          </>
                        )
                      }}
                    </Form.Item>
                  </Card>

                  <Card title="Preview">
                    <Form.Item shouldUpdate noStyle>
                      {({ getFieldValue }) => {
                        const bg = getFieldValue('prizePageBackgroundUrl')
                        const logo = getFieldValue('prizePageLogoUrl')
                        const frame = getFieldValue('prizePageFrameUrl')
                        const title = getFieldValue('prizePageTitle') || 'PARABÉNS!'
                        const subtitle = getFieldValue('prizePageSubtitle') || 'VOCÊ GANHOU'
                        const titleColor = getFieldValue('prizePageTitleColor') || '#fff200'
                        const subtitleColor = getFieldValue('prizePageSubtitleColor') || '#00a6c8'
                        const prizeColor = getFieldValue('prizePagePrizeNameColor') || '#fff200'
                        const titleFontSize =
                          Number(
                            getFieldValue(
                              'prizePageTitleFontSize',
                            ) || 76,
                          )

                        const titleFontWeight =
                          getFieldValue(
                            'prizePageTitleFontWeight',
                          ) || '950'

                        const titleSpacing =
                          Number(
                            getFieldValue(
                              'prizePageTitleSpacing',
                            ) ?? 24,
                          )

                        const subtitleFontSize =
                          Number(
                            getFieldValue(
                              'prizePageSubtitleFontSize',
                            ) || 48,
                          )

                        const subtitleFontWeight =
                          getFieldValue(
                            'prizePageSubtitleFontWeight',
                          ) || '900'

                        const subtitleSpacing =
                          Number(
                            getFieldValue(
                              'prizePageSubtitleSpacing',
                            ) ?? 14,
                          )

                        const prizeNameFontSize =
                          Number(
                            getFieldValue(
                              'prizePagePrizeNameFontSize',
                            ) || 84,
                          )

                        const prizeNameFontWeight =
                          getFieldValue(
                            'prizePagePrizeNameFontWeight',
                          ) || '950'

                        const prizeTextTransform =
                          getFieldValue(
                            'prizePagePrizeTextTransform',
                          ) || 'uppercase'

                        return (
                          <div
                            style={{
                              minHeight: 620,
                              borderRadius: 24,
                              padding: 32,
                              background: bg
                                ? `url(${getImageUrl(bg)}) center/cover no-repeat`
                                : '#050505',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              textAlign: 'center',
                              overflow: 'hidden',
                            }}
                          >
                            {logo && (
                              <img
                                src={getImageUrl(logo)}
                                alt="Logo"
                                style={{
                                  maxWidth: 220,
                                  maxHeight: 100,
                                  objectFit: 'contain',
                                  marginBottom: 32,
                                }}
                              />
                            )}

                            <div
                              style={{
                                width: 430,
                                height: 430,
                                maxWidth: '92%',
                                position: 'relative',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              {frame && (
                                <img
                                  src={getImageUrl(frame)}
                                  alt="Moldura"
                                  style={{
                                    position: 'absolute',
                                    inset: 0,
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain',
                                    zIndex: 1,
                                  }}
                                />
                              )}

                              <div style={{ position: 'relative', zIndex: 2 }}>
                                <div style={{ color: titleColor, fontSize: titleFontSize, fontWeight: titleFontWeight, marginBottom: titleSpacing, textTransform: 'uppercase', }}
                                >
                                  {title}
                                </div>

                                <div
                                  style={{
                                    color: subtitleColor,
                                    fontSize: subtitleFontSize,
                                    fontWeight: subtitleFontWeight,
                                    marginBottom: subtitleSpacing,
                                    textTransform: 'uppercase',
                                  }}
                                >
                                  {subtitle}
                                </div>

                                <div
                                  style={{
                                    color: prizeColor,
                                    fontSize: prizeNameFontSize,
                                    fontWeight: prizeNameFontWeight,
                                    textTransform: prizeTextTransform,
                                    lineHeight: 1,
                                    marginTop: 18,
                                  }}
                                >
                                  GARRAFA
                                  <br />
                                  TÉRMICA
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      }}
                    </Form.Item>
                  </Card>
                </>
              ),
            },
            {
              key: 'idle-screen',
              label: 'Tela de Espera',
              children: (
                <>
                  <Alert
                    showIcon
                    type="info"
                    style={{
                      marginBottom: 24,
                    }}
                    message="A tela de espera aparece após um período sem interação no totem."
                    description="Ao tocar na tela, o participante retorna ao jogo."
                  />

                  <Card
                    title="Comportamento"
                    style={{
                      marginBottom: 24,
                    }}
                  >
                    <Row gutter={[16, 16]}>
                      <Col xs={24} md={6}>
                        <Form.Item
                          name="idleScreenEnabled"
                          label="Ativar tela de espera"
                          valuePropName="checked"
                        >
                          <Switch />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={6}>
                        <Form.Item
                          name="idleScreenShowBackground"
                          label="Mostrar imagem de fundo"
                          valuePropName="checked"
                        >
                          <Switch />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={6}>
                        <Form.Item
                          name="idleScreenShowVideo"
                          label="Mostrar vídeo de fundo"
                          valuePropName="checked"
                        >
                          <Switch />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={6}>
                        <Form.Item
                          name="idleScreenDelay"
                          label="Tempo para ativar (ms)"
                          extra="Exemplo: 30000 equivale a 30 segundos."
                        >
                          <InputNumber
                            min={1000}
                            max={3600000}
                            step={1000}
                            style={{
                              width: '100%',
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Alert
                      showIcon
                      type="warning"
                      message="A imagem tem prioridade sobre o vídeo."
                      description="Quando Mostrar imagem de fundo estiver ativado e houver uma imagem cadastrada, o vídeo não será exibido."
                    />
                  </Card>

                  <Card
                    title="Mensagem"
                    style={{
                      marginBottom: 24,
                    }}
                  >
                    <Form.Item
                      name="idleScreenMessage"
                      label="Mensagem da tela de espera"
                    >
                      <Input.TextArea
                        rows={3}
                        placeholder="Toque na tela para começar"
                      />
                    </Form.Item>

                    <Row gutter={[16, 16]}>
                      <Col xs={24} md={8}>
                        <Form.Item
                          name="idleScreenMessageColor"
                          label="Cor da mensagem"
                        >
                          <Input type="color" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item
                          name="idleScreenMessageFontSize"
                          label="Tamanho da mensagem"
                        >
                          <InputNumber
                            min={14}
                            max={200}
                            style={{
                              width: '100%',
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item
                          name="idleScreenOverlayOpacity"
                          label="Opacidade da camada (%)"
                        >
                          <InputNumber
                            min={0}
                            max={100}
                            style={{
                              width: '100%',
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={8}>
                        <Form.Item
                          name="idleScreenOverlayColor"
                          label="Cor da camada"
                        >
                          <Input type="color" />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Col xs={24} md={8}>
                      <Form.Item
                        name="idleScreenMessagePosition"
                        label="Posição da mensagem"
                      >
                        <Select
                          options={[
                            {
                              label: 'Topo',
                              value: 'TOP',
                            },
                            {
                              label: 'Centro',
                              value: 'CENTER',
                            },
                            {
                              label: 'Rodapé',
                              value: 'BOTTOM',
                            },
                          ]}
                        />
                      </Form.Item>
                    </Col>
                  </Card>

                  <Card
                    title="Imagem de Fundo"
                    style={{
                      marginBottom: 24,
                    }}
                  >
                    <Form.Item
                      name="idleScreenBackgroundUrl"
                      label="Imagem da tela de espera"
                    >
                      <Input
                        placeholder="URL da imagem ou envie abaixo"
                      />
                    </Form.Item>

                    <Upload
                      customRequest={
                        uploadIdleBackground
                      }
                      showUploadList={false}
                      accept=".png,.jpg,.jpeg,.webp,.gif"
                    >
                      <Button
                        icon={<UploadOutlined />}
                        loading={
                          uploadingIdleBackground
                        }
                      >
                        Enviar imagem
                      </Button>
                    </Upload>

                    <Form.Item
                      shouldUpdate
                      noStyle
                    >
                      {({ getFieldValue }) => {
                        const url =
                          getFieldValue(
                            'idleScreenBackgroundUrl',
                          )

                        return url ? (
                          <div
                            style={{
                              marginTop: 16,
                            }}
                          >
                            <Image
                              src={getImageUrl(url)}
                              height={180}
                              style={{
                                width: '100%',
                                objectFit: 'cover',
                                borderRadius: 12,
                              }}
                            />
                          </div>
                        ) : null
                      }}
                    </Form.Item>
                  </Card>

                  <Card
                    title="Vídeo de Fundo"
                    style={{
                      marginBottom: 24,
                    }}
                  >
                    <Alert
                      showIcon
                      type="info"
                      style={{
                        marginBottom: 16,
                      }}
                      message="O vídeo será exibido em loop, sem som."
                      description="Ele será utilizado quando a imagem estiver desativada ou não tiver uma URL cadastrada."
                    />

                    <Form.Item
                      name="idleScreenVideoUrl"
                      label="Vídeo da tela de espera"
                    >
                      <Input
                        placeholder="URL do vídeo ou envie abaixo"
                      />
                    </Form.Item>

                    <Upload
                      customRequest={
                        uploadIdleVideo
                      }
                      showUploadList={false}
                      accept=".mp4,.webm"
                    >
                      <Button
                        icon={<UploadOutlined />}
                        loading={
                          uploadingIdleVideo
                        }
                      >
                        Enviar vídeo
                      </Button>
                    </Upload>

                    <Form.Item
                      shouldUpdate
                      noStyle
                    >
                      {({ getFieldValue }) => {
                        const url =
                          getFieldValue(
                            'idleScreenVideoUrl',
                          )

                        return url ? (
                          <div
                            style={{
                              marginTop: 16,
                              maxWidth: 420,
                            }}
                          >
                            <video
                              src={getImageUrl(url)}
                              controls
                              muted
                              loop
                              playsInline
                              style={{
                                display: 'block',
                                width: '100%',
                                maxHeight: 320,
                                objectFit: 'cover',
                                borderRadius: 12,
                                background: '#000000',
                              }}
                            />
                          </div>
                        ) : null
                      }}
                    </Form.Item>
                  </Card>

                  <Card title="Preview da Tela de Espera">
                    <Form.Item
                      shouldUpdate
                      noStyle
                    >
                      {({ getFieldValue }) => {
                        const showBackground =
                          getFieldValue(
                            'idleScreenShowBackground',
                          ) !== false

                        const backgroundUrl =
                          getFieldValue(
                            'idleScreenBackgroundUrl',
                          )

                        const showVideo =
                          getFieldValue(
                            'idleScreenShowVideo',
                          ) === true

                        const videoUrl =
                          getFieldValue(
                            'idleScreenVideoUrl',
                          )

                        const messageText =
                          getFieldValue(
                            'idleScreenMessage',
                          ) ||
                          'Toque na tela para começar'

                        const messageColor =
                          getFieldValue(
                            'idleScreenMessageColor',
                          ) ||
                          '#ffffff'

                        const messageFontSize =
                          Number(
                            getFieldValue(
                              'idleScreenMessageFontSize',
                            ) || 48,
                          )

                        const messagePosition =
                          getFieldValue(
                            'idleScreenMessagePosition',
                          ) || 'CENTER'

                        const messageVerticalAlignment =
                          messagePosition === 'TOP'
                            ? 'flex-start'
                            : messagePosition === 'BOTTOM'
                              ? 'flex-end'
                              : 'center'

                        const overlayColor =
                          getFieldValue(
                            'idleScreenOverlayColor',
                          ) ||
                          '#000000'

                        const overlayOpacity =
                          Number(
                            getFieldValue(
                              'idleScreenOverlayOpacity',
                            ) ?? 20,
                          ) / 100

                        const shouldShowImage =
                          showBackground &&
                          Boolean(backgroundUrl)

                        const shouldShowVideo =
                          !shouldShowImage &&
                          showVideo &&
                          Boolean(videoUrl)

                        return (
                          <div
                            style={{
                              position: 'relative',
                              width: '100%',
                              minHeight: 620,
                              overflow: 'hidden',
                              borderRadius: 24,
                              background: '#050505',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent:
                                messageVerticalAlignment,
                            }}
                          >
                            {shouldShowImage && (
                              <img
                                src={getImageUrl(
                                  backgroundUrl,
                                )}
                                alt="Fundo da tela de espera"
                                style={{
                                  position: 'absolute',
                                  inset: 0,
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                }}
                              />
                            )}

                            {shouldShowVideo && (
                              <video
                                src={getImageUrl(
                                  videoUrl,
                                )}
                                autoPlay
                                muted
                                loop
                                playsInline
                                style={{
                                  position: 'absolute',
                                  inset: 0,
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                }}
                              />
                            )}

                            <div
                              style={{
                                position: 'absolute',
                                inset: 0,
                                background:
                                  overlayColor,
                                opacity:
                                  overlayOpacity,
                              }}
                            />

                            <div
                              style={{
                                position: 'relative',
                                zIndex: 2,
                                maxWidth: '86%',
                                padding: 32,

                                color: messageColor,
                                fontSize: messageFontSize,
                                fontWeight: 900,
                                lineHeight: 1.1,

                                textAlign: 'center',
                                whiteSpace: 'pre-line',

                                marginTop:
                                  messagePosition === 'TOP'
                                    ? 48
                                    : 0,

                                marginBottom:
                                  messagePosition === 'BOTTOM'
                                    ? 48
                                    : 0,

                                textShadow:
                                  '0 4px 14px rgba(0,0,0,.65)',
                              }}
                            >
                              {messageText}
                            </div>
                          </div>
                        )
                      }}
                    </Form.Item>
                  </Card>
                </>
              ),
            },
          ]}
        />
      </Form>
    </>
  )
}

export default SettingsPage